import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { deferDateTime } from "../../../shared/src/codecs/types/deferDateTime";
import { formIO, TFormIOCodec } from "../../../shared/src/codecs/types/formIO";
import { nullCodec } from "../../../shared/src/codecs/types/nullCodec";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { union } from "../../../shared/src/codecs/types/union";
import { uuid } from "../../../shared/src/codecs/types/uuid";
import { EmptyObject } from "../EmptyObject";

export const AdHocTaskDeferInput = required({
    id: uuid(),
    deferred_date: union([nullCodec(), deferDateTime()]),
});
export type TAdHocTaskDeferInputCodec = typeof AdHocTaskDeferInput;

export const AdHocTaskDeferFormIO: TFormIOCodec<TAdHocTaskDeferInputCodec, TRequiredCodec<{}>> = formIO(
    AdHocTaskDeferInput,
    EmptyObject,
);
export type TAdHocTaskDeferFormIOCodec = typeof AdHocTaskDeferFormIO;
export type TAdHocTaskDeferFormIO = TTypeOfCodec<typeof AdHocTaskDeferFormIO>;
